<script setup lang="ts">
/**
 * Cancel/Submit button pair for edit forms.
 * Stacks vertically on mobile (submit on top via col-reverse),
 * horizontal on desktop. Includes bottom padding for mobile nav clearance.
 */
withDefaults(
  defineProps<{
    submitLabel?: string
    loading?: boolean
    cancelLabel?: string
  }>(),
  {
    submitLabel: "Save",
    cancelLabel: "Cancel",
  },
)

defineEmits<{
  cancel: []
}>()
</script>

<template>
  <div class="flex flex-col-reverse gap-2 pt-4 pb-16 sm:flex-row sm:justify-end sm:pb-0 lg:pb-0">
    <UButton
      :label="cancelLabel"
      color="neutral"
      variant="outline"
      size="xl"
      block
      @click="$emit('cancel')"
    />
    <UButton type="submit" :label="submitLabel" :loading="loading" size="xl" block />
  </div>
</template>
